import { TransactionIcon, CursorIcon, SearchIcon, MinimizeIcon, RefreshIcon, ChatIcon, DeliveryIcon } from '@shopify/polaris-icons';
import CourierSettings from './components/CourierMapping/components/CourierSettings';
import CarrierMapping from './components/CarrierMapping';
import TrackingLink from './components/TrackingLink';
import OrderLookup from './components/OrderLookup';
import Integration from './components/Integration';
import SyncStatus from './components/SyncStatus';
import AiAssistants from './components/AiAssistants';
import { IConfigTab } from '@/types/tab';

export const tabsConfig: Array<IConfigTab> = [
  {
    value: 'trackingLink',
    label: 'Tracking Link Set-up',
    component: <TrackingLink />,
    icon: CursorIcon,
  },
  {
    value: 'frequentlyUsedCouriers',
    label: 'Frequently used couriers',
    component: <CourierSettings />,
    icon: DeliveryIcon,
  },
  {
    value: 'carrierMapping',
    label: 'Carrier mapping',
    component: <CarrierMapping />,
    icon: TransactionIcon,
  },
  {
    value: 'syncStatus',
    label: 'Sync status to Shopify',
    component: <SyncStatus />,
    icon: RefreshIcon,
  },
  {
    value: 'orderLookUp',
    label: 'Order Lookup Widget',
    component: <OrderLookup />,
    icon: SearchIcon,
  },
  {
    value: 'integration',
    label: 'Integration',
    component: <Integration />,
    icon: MinimizeIcon,
  },
  {
    value: 'aiAssistants',
    label: 'AI Assistants',
    component: <AiAssistants />,
    icon: ChatIcon,
  },
  // {
  //   value: 'updateTheme',
  //   label: 'Update theme 2.0',
  //   component: <UpdateTheme />,
  //   icon: IqIcon,
  // },
];
